const recentConfigsSelector = (state) => state.apps.manual.recentAndSavedConfigs.get('recentConfigs');
const savedConfigsSelector = (state) => state.apps.manual.recentAndSavedConfigs.get('savedConfigs');
const recentAndSavedConfigsLoadedSelector = (state) => (
  state.apps.manual.recentAndSavedConfigs.get('recentAndSavedConfigsLoaded')
);

export default {
  recentConfigsSelector,
  recentAndSavedConfigsLoadedSelector,
  savedConfigsSelector,
};
